import React, { useEffect, useState } from "react";
import data from "../../data.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import styles from "./index.module.scss";
// import Ornament from "./ornament.svg";
var GUESTS = data.guests;
export var Intro = function () {
    var SPEED = 2.5;
    var _a = useState({
        gender: "Male",
        name: "",
    }), guest = _a[0], setGuest = _a[1];
    useEffect(function () {
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        var hash = urlParams.get("h");
        if (hash === null)
            return;
        setGuest(GUESTS[hash]);
    }, []);
    useEffect(function () {
        var paths = Array.from(document.querySelectorAll("." + styles.names + " path"));
        var data = paths
            .map(function (path) {
            var length = path.getTotalLength();
            var time = length / SPEED / 1000;
            return { length: length, time: time, path: path };
        });
        var _loop_1 = function (i) {
            var _a = data[i], path = _a.path, length_1 = _a.length, time = _a.time;
            var delay = 0;
            for (var j = 0; j < i; ++j) {
                var time_1 = data[j].time;
                delay += time_1;
            }
            path.setAttribute("style", "\n\t\t\t\t--stroke-length: " + length_1 + ";\n\t\t\t\t--delay: " + delay + "s;\n\t\t\t\t--time: " + time + "s;\n\t\t\t");
            setTimeout(function () {
                path.style.opacity = "1";
            }, (1000 + 50) * delay);
        };
        for (var i = 0; i < data.length; ++i) {
            _loop_1(i);
        }
    }, []);
    return React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.invit }, guest === null || guest === void 0 ? void 0 :
            guest.name,
            guest.name === "" ? "" : ", ",
            (function () {
                switch (guest === null || guest === void 0 ? void 0 : guest.gender) {
                    case undefined:
                        return "...";
                    case "Female":
                        return "tu es invitée au mariage de";
                    case "Male":
                        return "tu es invité au mariage de";
                    case "Males":
                        return "vous êtes invités au mariage de";
                }
            })()),
        React.createElement("div", { className: styles.names }, "\uE038un\uE000quenti\uE066"),
        React.createElement(FontAwesomeIcon, { icon: faArrowDown, className: styles.arrow }));
};
